import { tap } from "rxjs/operators";
import {
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  NavigationExtras,
} from "@angular/router";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { TranslationService } from "@cemex-core/angular-localization-v7";
import { ErrorType } from "../../error/models/error-type.enum";

@Injectable()
export class LanguageGuard implements CanActivateChild {
  constructor(private router: Router, private translation: TranslationService) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (childRoute.data.skipGuard) {
      return true;
    }
    return this.translation.languageLoaded.pipe(
      tap(
        (x) =>
          !x &&
          this.router.navigate(["invoices-payments", "error", { fragment: ErrorType.Language } as NavigationExtras])
      )
    );
  }
}
